<template>
  <v-container class="pt-6">
    <v-skeleton-loader
      :loading="true"
      :types="skeleton"
      type="article"
      class="mb-6"
    >
    </v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@4',
      },
    };
  },
  created() {
    this.$router.push({
      name: 'arrange',
    });
  },
};
</script>
